<template>
    <div style="display: none;"></div>
</template>
<script>
export default {
    name: 'yandex-metrika',
    props: {
        counterId: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        options: {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
        },
    }),
    mounted() {
        this.$store.dispatch('users/checkCookieConsent');
        this.loadYandexMetrika();
    },
    computed: {
        cookieConsent() {
            return this.$store.state.users.cookieConsent;
        },
    },
    methods: {
        loadYandexMetrika() {
            if (window.location.hostname === 'localhost') {
                console.warn('Yandex.Metrika prevented for localhost');
                window.ym = () => {};
                return;
            }

            // if (!this.cookieConsent) {
            //     this.options.webvisor = false;
            // }

            if (window.ym) {
                this.initMetrika();
                return;
            }

            window.ym = function() {
                (window.ym.a = window.ym.a || []).push(arguments);
            };
            window.ym.l = 1 * new Date();

            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://mc.yandex.ru/metrika/tag.js';
            script.onload = this.initMetrika; // Инициализируем после загрузки
            script.onerror = () => console.error('Ошибка загрузки Яндекс.Метрики');

            const firstScript = document.getElementsByTagName('script')[0];
            firstScript.parentNode.insertBefore(script, firstScript);

            // Noscript fallback (для пользователей без JS)
            const noscript = document.createElement('noscript');
            const img = document.createElement('img');
            img.src = `https://mc.yandex.ru/watch/${this.counterId}`;
            img.style = 'position:absolute; left:-9999px;';
            img.alt = '';
            noscript.appendChild(img);
            document.body.appendChild(noscript);
        },
        initMetrika() {
            window.ym(this.counterId, 'init', this.options);
        },
    },
    watch: {
        cookieConsent: function(newVal) {
            if (newVal) {
                this.loadYandexMetrika();
            }
        },
    },
};
</script>
